import { createAction, props, union } from '@ngrx/store';

import { InfChangeDepotI } from 'src/app/api/inf-change-depot/inf-change-depot.result.int';
import { InfChangeDepotQueryI } from 'src/app/api/inf-change-depot/inf-change-depot.query.int';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';

/* eslint-disable max-len */
export const error = createAction('[INF / ChangeDepot] Error', props<{ error: SharedErrorObjectI }>());
export const load = createAction('[INF / ChangeDepot] Load', props<{
    query: InfChangeDepotQueryI;
}>());
export const received = createAction('[INF / ChangeDepot] Received', props<{
    result: InfChangeDepotI;
}>());
export const reset = createAction('[INF / ChangeDepot] Reset', props<Record<string, unknown>>());

const all = union({
    error,
    load,
    received,
    reset,
});
export type Actions = typeof all;
